import { SegmentedControl } from '@/shared/components/ui/SegmentedControl';
import { LOCALES, type Locale } from './locales';
import { useI18n } from './useT';

/**
 * Language selector. Present in Settings on BOTH brands.
 * Language names are shown in their own language (autonyms), so they are read
 * from the message files rather than translated per active locale.
 */
interface Props {
  readonly compact?: boolean;
}

export function LocaleSwitcher({ compact = false }: Props) {
  const { locale, setLocale, t } = useI18n();

  return (
    <SegmentedControl<Locale>
      legend={t('settings.language.label')}
      name="locale"
      value={locale}
      onChange={setLocale}
      compact={compact}
      options={LOCALES.map((value) => ({
        value,
        label: compact ? value.toUpperCase() : t(`language.${value}`),
        ariaLabel: t(`language.${value}`),
      }))}
    />
  );
}
